import { render } from "./commentEdit.vue?vue&type=template&id=2952cca1"
import script from "./commentEdit.vue?vue&type=script&lang=js"
export * from "./commentEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__